import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogContentText,
  IconButton,
  Box,
} from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { Close } from '@mui/icons-material'
import RichText from '../RichText'
import { ReferenceType } from 'types/references'

type ModalProps = {
  open: boolean
  onClose: () => void
  rawBody: string
  references?: ReferenceType[]
}

export default function ComplianceModal({
  open,
  onClose,
  rawBody,
  references,
}: ModalProps): JSX.Element {
  const { classes } = useStyles()

  return (
    <Dialog
      fullScreen
      scroll="body"
      className={classes.dialog}
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      PaperProps={{
        className: classes.paper,
      }}
    >
      <IconButton
        aria-label="close"
        className={classes.closeButton}
        onClick={onClose}
        size="large"
      >
        <Close />
      </IconButton>
      <Box className={classes.box}>
        <DialogContent className={classes.content}>
          <DialogContentText id="modal-description">
            <RichText rawBody={rawBody} references={references} />
          </DialogContentText>
        </DialogContent>
      </Box>
    </Dialog>
  )
}

const useStyles = makeStyles()((theme) => ({
  dialog: {
    [theme.breakpoints.up(theme.breakpoints.values.tablet + 1)]: {
      marginBlock: theme.spacing(6),
      marginInline: theme.spacing(10),
    },

    margin: theme.spacing(2.5),
  },
  closeButton: {
    position: 'fixed',
    top: 0,
    right: 0,
    color: theme.palette.background.default,
    background: theme.palette.primary.dark,
    borderRadius: 0,
    width: theme.spacing(1),
    height: theme.spacing(1),
    margin: theme.spacing(1),
    '&:hover': {
      background: theme.palette.action.hover,
    },
  },
  box: {
    [theme.breakpoints.up('sm')]: {
      paddingInline: theme.spacing(4),
      paddingBlock: theme.spacing(2),
    },

    padding: theme.spacing(2),
  },
  content: {
    padding: 0,
  },
  paper: {
    borderRadius: theme.spacing(1),
  },
}))
